module.exports = __webpack_public_path__ + "img/u1215.60e100f6.png";